import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type recalculateAOTechnicalInfoType = {
  id: string;
  errorCallback: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  errorCallback,
  resultKey = 'recalculateAOTechnicalInfoData',
  successCallback,
}: recalculateAOTechnicalInfoType) =>
  requestAsync({
    url: endpoints.getRecalculateAOTechnicalInfoUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getRecalculateAOTechnicalInfoUrl(id),
    body: {},
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      errorCallback,
      successCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
